import { SystemLogEventLevelKinds } from "./SystemLogEventLevelKinds";

export class SystemLogInformation {
  level: SystemLogEventLevelKinds;
  patientId: string;
  message: string;
}
